export default "__VITE_ASSET__MpQru3Ye__"